// @flow
import * as React from 'react';
import { graphql } from 'react-apollo';
import uuid from 'uuid';
import axios from 'axios';

import { buildForm } from 'components/File';
import API from 'lib/RemindAPI';
import errorLogger from 'utils/errorLogger';
import PUT_STUDENT_ID_LIST_MUTATION from '../queries/PutStudentIdListMutation.gql';
import ToastActions from 'actions/ToastActions';

export const PRIVATE_UPLOAD = true;

type Props = {
  children: Function,
  onUploadSuccess: (data: {
    studentIdListUuid: string,
    csvName: string,
  }) => void,
  selectedSchoolUuid: string,

  // graphql mutations
  mutate: ({
    variables: {
      input: {
        uuid: string,
        fileUuid: string,
        organizationUuid: string,
        includeParents?: boolean,
        includeStudents?: boolean,
      },
    },
  }) => Promise<*>,
};

type State = {
  csvIsMatching: boolean,
  csvMatchError?: ?Error,
};

class TargetByStudentIdUploadPageContainer extends React.Component<Props, State> {
  state = {
    csvIsMatching: false,
    csvMatchError: null,
  };

  async uploadFile(file: *, onUploadProgress: Function, onUploadSuccess: Function) {
    const data = await API.request('/files', 'POST', {
      file: { name: file.name },
      private: PRIVATE_UPLOAD,
    });
    const form = buildForm(data.fields, file);
    await axios.post(data.upload_url, form, {
      onUploadProgress,
    });

    onUploadSuccess(data);
  }

  handlePutStudentIdList = (file: *) => {
    this.setState({ csvIsMatching: true });
    const studentListUuid = uuid.v4();
    this.props
      .mutate({
        variables: {
          input: {
            uuid: studentListUuid,
            fileUuid: file.id,
            organizationUuid: this.props.selectedSchoolUuid,
          },
        },
      })
      .then(
        response => {
          this.setState({
            csvIsMatching: false,
          });

          const { results, error } = response.data.putStudentIdList;
          if (results) {
            this.props.onUploadSuccess({
              studentIdListUuid: results.uuid,
              csvName: file.fields.Filename,
            });
          }
          if (error) {
            this.setState({ csvMatchError: error });
          }
        },
        err => {
          this.setState({
            csvIsMatching: false,
          });
          ToastActions.showErrorToast(
            'Oops! Looks like something went wrong. Please try again later.'
          );
          console.error('TBSI - putStudentIdList error during handleUploadSuccess');
          console.warn(err);
        }
      )
      .catch(errorLogger('TBSI - putStudentIdList runtime error during handleUploadSuccess'));
  };

  render() {
    return this.props.children({
      onUploadSuccess: this.handlePutStudentIdList,
      csvIsMatching: this.state.csvIsMatching,
      csvMatchError: this.state.csvMatchError,
      uploadFile: this.uploadFile,
    });
  }
}

const withMutation = graphql(PUT_STUDENT_ID_LIST_MUTATION);

export { TargetByStudentIdUploadPageContainer };

export default withMutation(TargetByStudentIdUploadPageContainer);
